import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { getClientRegionCode, getSiteRegion } from '../../lib/get-default-region'
import { IS_LOCAL } from '../../constant'

const REGION = { AU: 'au', EU: 'eu', US: 'us' }
const SITE_REGION = getSiteRegion()

function redirectToRegion (regionCode, redirectPath) {
  console.assert(regionCode, 'Missing regionCode')
  console.assert(redirectPath, 'Missing redirectPath')
  const params = new URLSearchParams(window.location.search)
  params.set('regionCode', regionCode)
  const redirectTo = `${window.location.origin}/${regionCode}${redirectPath}?${params.toString()}`
  if (IS_LOCAL) {
    console.log('Skip redirect localhost:', redirectTo)
    return
  }
  console.log('Redirecting to region specific site: ', redirectTo)
  window.location.replace(redirectTo)
}

export default function RegionSelector ({ label, redirectPath }) {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedRegion = getClientRegionCode()
  const { t } = useTranslation()

  useEffect(() => {
    if (selectedRegion && selectedRegion !== SITE_REGION) {
      redirectToRegion(selectedRegion, redirectPath)
    } else if (!selectedRegion && !SITE_REGION) {
      redirectToRegion('au', redirectPath)
    }
  }, [selectedRegion, redirectPath])

  const handleChange = (e) => {
    const selectedRegion = e.target.value
    searchParams.set('regionCode', selectedRegion)
    setSearchParams(Object.fromEntries(searchParams.entries()))
  }

  return (
    <div className='flex items-center py-3 space-x-8'>
      <span className='font-medium'>{label}</span>
      <label className='space-x-2'>
        <input
          type='radio'
          value={REGION.AU}
          checked={selectedRegion === REGION.AU}
          onChange={handleChange}
        /> <span>{t('regionSelector_au')}</span>
      </label>
      <label className='space-x-2'>
        <input
          type='radio'
          value={REGION.EU}
          checked={selectedRegion === REGION.EU}
          onChange={handleChange}
        /> <span>{t('regionSelector_eu')}</span>
      </label>
      <label className='space-x-2'>
        <input
          type='radio'
          value={REGION.US}
          checked={selectedRegion === REGION.US}
          onChange={handleChange}
        /> <span>{t('regionSelector_us')}</span>
      </label>
    </div>
  )
}
